export default [
  // 发票预览
  {
    path: '/ticket-previewTicket',
    component: () => import('@/views/ticket/previewTicket'),
    name: 'ticket-previewTicket',
    meta: {
      auth: 0,
      backgroundClass: 'bg-gray',
    },
  },
];
